import '../App.css';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import {Bodyheadregister} from './/bodyheadregister';
import { useNavigate } from "react-router-dom";
import Axios from 'axios';
import React, {useEffect, useState} from 'react';
import { clearImpersonationState } from '../utils/impersonation';

function Bodyloginsa(props){
    const [profile, setProfile] = useState([]);
    const [user, setUser] = useState('');
    const [userType, setUserType] = useState('4');
    const [pass, setPass] = useState('');
    const [alertHead, setAlertHead] = useState('');
    const [alertBody, setAlertBody] = useState('');
    const [alertActivate, setAlertActivate] = useState(false);
    const [alertClass, setAlertClass] = useState('')
    const [authCode, setAuthCode] = useState('');
    const [apiKey, setApiKey] = useState('');

    let statuscall = '' 
    const navigate = useNavigate();

    const profileList = profile.map((item, i) => 
        <option key={i} value={item.id}>{item.nombre}</option>
    );



    useEffect(() => {       
        Axios.get(process.env.REACT_APP_URLPROFILE, { 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setProfile(response.data);
        }).catch(error => {
           return error     
        });
    }, []);

    const setUserLogin = (e) =>
    {
        setUser(e.target.value)
    }

    const setTypeUser = (e) => 
    {
        /*this.setState({userType: event.target.value});*/ 
        setUserType(e.target.value)  
    }

    const setPassword = (e) =>
    {
        /*this.setState({pass: event.target.value});*/
        setPass(e.target.value)
    }

    const login = async (e) =>{
        const data = {       
            profile_id: userType,
            mail: user,
            password: pass,
        };

        const userLogin = await Axios.get(process.env.REACT_APP_URLAUTENTICATE, {
            params: {
                profile_id: userType, 
                mail: user, 
                password: pass 
            },
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }}).then(res => statuscall = res).catch(err => statuscall = err.response);
            
            if(statuscall.status == 200)
            {
                clearImpersonationState()
                window.localStorage.setItem('MY_APP_STATE_USER', JSON.stringify(user))
                window.localStorage.setItem('MY_APP_STATE_APIKEY', JSON.stringify(statuscall.data.ApiKey))
                window.localStorage.setItem('MY_APP_STATE_AUTHCODE', JSON.stringify(statuscall.data.AuthCode))
                window.localStorage.setItem('MY_APP_STATE_ROLE', JSON.stringify(statuscall.data.roles))
                window.localStorage.setItem('MY_APP_STATE_PROF_ID', JSON.stringify(statuscall.data.perfil.id_perfil))
                window.localStorage.setItem('MY_APP_STATE_PROF_NAME', JSON.stringify(statuscall.data.perfil.fullname))
                window.localStorage.setItem('MY_APP_STATE_PROF_PROF', JSON.stringify(statuscall.data.perfil.perfil))
                window.localStorage.setItem('MY_APP_STATE_PROV_VALOR', JSON.stringify(statuscall.data.perfil.valor_ticket))
                window.localStorage.setItem('MY_APP_STATE_PROF_CASINO', JSON.stringify(statuscall.data.perfil.casino))
                window.localStorage.setItem('MY_APP_STATE_PROF_CASINO_ID', JSON.stringify(statuscall.data.perfil.casino_id))                   
                
                setAlertClass('success')
                setAlertHead(statuscall.data.MessageCode)
                setAlertBody(statuscall.data.Message)
                setAlertActivate(true)
                setTimeout(() => {
                    setAlertActivate(false)
                    navigate('/Casinos/'+ statuscall.data.AuthCode)
                }, 2000)            
            }
            else
            {
                setAlertClass('danger')
                setAlertHead(statuscall.data.MessageCode)
                setAlertBody(statuscall.data.Message)
                setAlertActivate(true)
                setTimeout(() => {
                    setAlertActivate(false)
                }, 5000)
            }
    }

    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                
            </div>                
            <div className='sshbodyappContainerLoginCarrusel'>
                {alertActivate 
                    ?<Alert variant={alertClass} onClose={() => setAlertActivate(false)} dismissible>
                    <Alert.Heading>{alertHead} {user}</Alert.Heading>
                    <p>
                        {alertBody}
                    </p>
                </Alert>
                : ''
                }                
            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>

                    <div className='row justify-content-center separateRow'>
                        <div className='col col-lg-6'>
                            <h1>Entrar</h1>
                        </div>
                    </div>     

                    <div className='row justify-content-center separateRow'>
                        <div className='col col-lg-6'>
                            <Form.Control type="email" placeholder="name@example.com" onChange={setUserLogin} />
                        </div>
                    </div>

                    <div className='row justify-content-center separateRow'>
                        <div className='col col-lg-6'>
                            <Form.Control type="password" placeholder="****************" onChange={setPassword} />
                        </div>
                    </div>
                                
                    <div className='row justify-content-center separateRow'>
                        <div className='col col-lg-6'>
                            <div className="d-grid gap-2">
                                <Button variant="adminsa" size="lg" onClick={login}>
                                    Entrar
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className='row justify-content-center separateRow'>
                        <div className='col col-lg-4'>
                            <div className="d-grid gap-2">
                            <Link to={`/RecoverPassword`}>Recuperar contraseña</Link>
                            </div>
                        </div>                        
                    </div> 

                </div>
            </div>
        </div>            
    )

}
export default Bodyloginsa
